import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  del,
  formDataPatch,
  formDataPost,
  patch,
  post,
  get
} from "helpers/api_helper";
import {
  ADD_WORKSPACE,
  CLONE_SPACE,
  DELETE_WORKSPACE,
  GET_ALL_WORKSHOP_REQUEST,
  GET_ALL_WORKSPACES,
  GET_MEETING_ROOMS_LIST,
  GET_WORKSHOP_INVOICE,
  GET_WORKSHOP_REQUEST_DETAILS,
  GET_WORKSPACE_DETAILS,
  UPDATE_WORKSHOP_REQUEST,
  UPDATE_WORKSHOP_REQUEST_STATUS,
  UPDATE_WORKSPACE,
  CASHBACK_UPDATE,
  UPDATE_WORKSPACE_STATUS,
  GET_SPACE_LIST_BY_TYPE,
  GET_ALL_WEBSITE_REQUESTS,
  UPDATE_WORKSHOP_REQUEST_SHARE,
  GET_WORKSPACE_LIST,
  GET_WORKSPACE_BOOKING_DETAILS,
  CHECK_ENTIRE_BRANCH,
  GET_NEW_WORKSHOP_REQUEST_COUNT,
  UPDATE_NEW_WORKSHOP_REQUEST_COUNT
} from "helpers/url_helper";

export const getAllWorkspaces = createAsyncThunk(
  GET_ALL_WORKSPACES,
  async (payload) => {
    const response = await post(GET_ALL_WORKSPACES, payload);
    return response;
  }
);

export const getWorkspaceDetails = createAsyncThunk(
  GET_WORKSPACE_DETAILS,
  async (payload) => {
    const response = await post(GET_WORKSPACE_DETAILS, payload);
    return response;
  }
);

export const addWorkspace = createAsyncThunk(ADD_WORKSPACE, async (payload) => {
  const response = await formDataPost(ADD_WORKSPACE, payload);
  return response;
});

export const updateWorkspace = createAsyncThunk(
  UPDATE_WORKSPACE,
  async (payload) => {
    const response = await formDataPatch(UPDATE_WORKSPACE, payload);
    return response;
  }
);
export const updatecashback = createAsyncThunk(
  CASHBACK_UPDATE,
  async (payload) => {
    const response = await formDataPatch(CASHBACK_UPDATE, payload);
    return response;
  }
);
export const updateWorkspaceStatus = createAsyncThunk(
  UPDATE_WORKSPACE_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_WORKSPACE_STATUS, payload);
    return response;
  }
);

export const deleteWorkspace = createAsyncThunk(
  DELETE_WORKSPACE,
  async (payload) => {
    const response = await del(DELETE_WORKSPACE, payload);
    return response;
  }
);

export const cloneSpace = createAsyncThunk(CLONE_SPACE, async (payload) => {
  const response = await post(CLONE_SPACE, payload);
  return response;
});

// export const getMeetingRoomsList = createAsyncThunk(
//   GET_MEETING_ROOMS_LIST,
//   async (spaceType) => {
//     const response = await get(
//       `${GET_MEETING_ROOMS_LIST}?spaceTypeInt=${spaceType}`
//     );
//     return response;
//   }
// );

export const getMeetingRoomsList = createAsyncThunk(
  GET_MEETING_ROOMS_LIST,
  async (payload) => {
    const response = await post(GET_MEETING_ROOMS_LIST, payload);
    return response;
  }
);

export const getAllWorkshopRequest = createAsyncThunk(
  GET_ALL_WORKSHOP_REQUEST,
  async (payload) => {
    const response = await post(GET_ALL_WORKSHOP_REQUEST, payload);
    return response;
  }
);

export const updateWorkshopRequestStatus = createAsyncThunk(
  UPDATE_WORKSHOP_REQUEST_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_WORKSHOP_REQUEST_STATUS, payload);
    return response;
  }
);

export const getWorkshopRequestDetails = createAsyncThunk(
  GET_WORKSHOP_REQUEST_DETAILS,
  async (payload) => {
    const response = await post(GET_WORKSHOP_REQUEST_DETAILS, payload);
    return response;
  }
);

export const updateWorkshopRequest = createAsyncThunk(
  UPDATE_WORKSHOP_REQUEST,
  async (payload) => {
    const response = await formDataPatch(UPDATE_WORKSHOP_REQUEST, payload);
    return response;
  }
);

export const getWorkshopInvoice = createAsyncThunk(
  GET_WORKSHOP_INVOICE,
  async (payload) => {
    const response = await post(GET_WORKSHOP_INVOICE, payload);
    return response;
  }
);

export const getSpaceListByType = createAsyncThunk(
  GET_SPACE_LIST_BY_TYPE,
  async (payload) => {
    const response = await post(GET_SPACE_LIST_BY_TYPE, payload);
    return response;
  }
);

export const getWebsiteRequests = createAsyncThunk(
  GET_ALL_WEBSITE_REQUESTS,
  async (payload) => {
    const response = await post(GET_ALL_WEBSITE_REQUESTS, payload);
    return response;
  }
);

export const updateWorkshopRequestShare = createAsyncThunk(
  UPDATE_WORKSHOP_REQUEST_SHARE,
  async (payload) => {
    const response = await patch(UPDATE_WORKSHOP_REQUEST_SHARE, payload);
    return response;
  }
);

export const getWorkspaceList = createAsyncThunk(
  GET_WORKSPACE_LIST,
  async (payload) => {
    const response = await post(GET_WORKSPACE_LIST, payload);
    return response;
  }
);

export const getWorkspaceBookingDetails = createAsyncThunk(
  GET_WORKSPACE_BOOKING_DETAILS,
  async (payload) => {
    const response = await post(GET_WORKSPACE_BOOKING_DETAILS, payload);
    return response;
  }
);

export const checkEntireBranch = createAsyncThunk(
  CHECK_ENTIRE_BRANCH,
  async (payload) => {
    const response = await post(CHECK_ENTIRE_BRANCH, payload);
    return response;
  }
);

export const getNewWorkshopRequestCount = createAsyncThunk(
  GET_NEW_WORKSHOP_REQUEST_COUNT,
  async (payload) => {
    const response = await get(GET_NEW_WORKSHOP_REQUEST_COUNT, payload);
    return response;
  }
);

export const updateNewWorkshopRequestCount = createAsyncThunk(
  UPDATE_NEW_WORKSHOP_REQUEST_COUNT,
  async (payload) => {
    const response = await patch(UPDATE_NEW_WORKSHOP_REQUEST_COUNT, payload);
    return response;
  }
);

